module.exports = __webpack_public_path__ + "img/Identity-Pattern3.89d12122.jpg";